<template>
  <section>
    <div class="relative flex flex-wrap w-full md:flex-row-reverse font-open-sans">
      <div class="relative flex items-center w-full px-5 md:w-1/2 py-9 xl:py-24">
        <div class="w-full space-y-3.5 lg:space-y-5 mx-auto">
          <h2 class="max-w-lg mx-auto text-3xl font-extrabold text-center md:text-4xl xl:text-6xl font-WWebMedium" v-html="mainHeading"></h2>
          <div class="max-w-lg mx-auto text-base text-center text-gray-700 md:text-lg lg:text-2xl pt-7 lg:px-6 custom-p" v-html="paragraph1"></div>
          <div class="max-w-lg mx-auto text-base text-center text-gray-700 md:text-lg lg:text-2xl pt-7 lg:px-6" v-html="paragraph2"></div>
        </div>
      </div>
      <div class="flex w-full md:w-1/2 md:ml-auto xl:pr-20">
        <div class="w-full">
          <div id="" class="aspect-auto">
            <nuxt-img :src="imageSrc" :alt="imageAlt" loading="lazy" format="webp" :width="824" :height="949" sizes="xs:320px sm:440px md:768px lg:503px xl:587px 2xl:824px" class="block w-full h-full m-auto"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  mainHeading: {
    type: String,
    default: 'A New Standard In Coffee'
  },
  paragraph1: {
    type: String,
    default: 'Not long ago, I didn’t drink coffee. I read the research on the harmful effects of conventional coffee loaded with toxins. However, the benefits of coffee were too hard to ignore. So I created the healthiest coffee possible so my patients and I could experience all the benefits with none of the drawbacks. Now it’s yours to enjoy too!'
  },
  paragraph2: {
    type: String,
    default: '- Dr. Charles Livingston, Founder of Lifeboost Coffee'
  },
  imageSrc: {
    type: String,
    default: '/assets/images/img-13.png'
  },
  imageAlt: {
    type: String,
    default: 'A New Standard In Coffee'
  },
});

defineBuilderComponent({
    friendlyName: "Content Left Image2",
    inputs: [
        {
            name: "mainHeading",
            type: "richText",
            defaultValue: "A New Standard In Coffee"
        },
        {
            name: "paragraph1",
            type: "richText",
            defaultValue: "Not long ago, I didn’t drink coffee. I read the research on the harmful effects of conventional coffee loaded with toxins. However, the benefits of coffee were too hard to ignore. So I created the healthiest coffee possible so my patients and I could experience all the benefits with none of the drawbacks. Now it’s yours to enjoy too!"
        },
        {
            name: "paragraph2",
            type: "richText",
            defaultValue: "- Dr. Charles Livingston, Founder of Lifeboost Coffee"
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "png"
            ],
            defaultValue: "/assets/images/img-13.png"
        },
        {
            name: "imageAlt",
            type: "string",
            defaultValue: "A New Standard In Coffee"
        }
    ]
});
</script>